import { Clock, Users, TrendingUp } from "lucide-react";

export interface UsageStat {
    id: string;
    icon: React.ElementType;
    value: string;
    label: string;
    highlight?: boolean; // for center / glow card
}

export const USAGE_STATS: UsageStat[] = [
    {
        id: "time-saved",
        icon: Clock,
        value: "4.2hrs",
        label: "Saved per day"
    },
    {
        id: "no-shows",
        icon: Users,
        value: "30%",
        label: "Fewer No Shows"
    },
    {
        id: "footfall",
        icon: TrendingUp,
        value: "3x",
        label: "Increased Footfall",
        highlight: true
    }
];
